import { type Market } from "../data/markets";
import supportDialogMarkets from "../data/supportDialogMarkets";

const marketHasSupportDialog = (market?: Market): boolean => {
  return Boolean(market && supportDialogMarkets.has(market.locale));
};

export default marketHasSupportDialog;
